"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.osmosis = exports.cosmos = exports.eip155 = exports.bip122 = void 0;
const adapter_json_1 = __importDefault(require("./bip122_000000000019d6689c085ae165831e93/adapter.json"));
exports.bip122 = adapter_json_1.default;
const adapter_json_2 = __importDefault(require("./eip155_1/adapter.json"));
exports.eip155 = adapter_json_2.default;
const adapter_json_3 = __importDefault(require("./cosmos_cosmoshub-4/adapter.json"));
exports.cosmos = adapter_json_3.default;
const adapter_json_4 = __importDefault(require("./cosmos_osmosis-1/adapter.json"));
exports.osmosis = adapter_json_4.default;
